module.exports = __webpack_public_path__ + "static/media/probike.899bd93e.png";